import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

import { ColorState } from './types';

type StatusMessageProps = {
  colorState: ColorState;
};

const statusColors = {
  [ColorState.Upcoming]: primitive.$upcomingHighlightStatus,
  [ColorState.Open]: primitive.$openHighlightStatus,
  [ColorState.Closed]: primitive.$closedHighlightStatus,
};

export const StatusMessage = styled.p<StatusMessageProps>`
  display: inline-block;
  margin: 0;
  font-family: ${Styles.fontFamily.base};
  font-size: 0.875rem;
  color: ${({ colorState }) => statusColors[colorState]};
`;
